<div class="paddingScreen py-3">
    <form class="login-form registration-form request-user-access" [formGroup]="requestAccessForm">
        <div class="row login pt-4">
            <ng-container *ngIf="isViewMode">
                <div class="row" [ngClass]="isArabic ? 'rowReverse' : ''">
                    <div class="col-8 labelSection d-flex flex-column p-0">
                        <label class="ques quesLabel" [ngClass]="isArabic ? 'rightAlign' : ''">
                            <span class="spanLabel">
                                <span *ngIf="!isArabic">Ticket Number : </span>
                                <span class="font-radikal-light">{{createdTicketNumber}}</span>
                                <span *ngIf="isArabic"> : رقم الطلب</span>
                            </span>
                        </label>
                        <label class="ques quesLabel" [ngClass]="isArabic ? 'rightAlign' : ''">
                            <span class="spanLabel">
                                <span *ngIf="!isArabic">Case Type : </span>
                                <span class="font-radikal-light">{{caseType}}</span>
                                <span *ngIf="isArabic">: نوع الطلب</span>
                            </span>
                        </label>
                    </div>
                    <div class="col-4 backBtn" [ngClass]="isArabic ? 'arabicAlign' : ''">
                        <button class="btn-lg btn-primary ratButton rightBtn" (click)="goToLastPage()">
                            <span *ngIf="!isArabic">back</span>
                            <span *ngIf="isArabic">العودة</span>
                        </button>
                    </div>
                </div>
            </ng-container>
            <div *ngIf="isAccessRequested" class="col-12">
                <alert type="success">
                    <p class="successAlert" [ngClass]="isArabic ? 'rightAlign' : ''">
                        <span *ngIf="!isArabic">Request has been successfully raised. Ticket Number :
                            {{ticketNumber}}</span>
                        <span *ngIf="isArabic">تم رفع الطلب بنجاح. رقم التذكرة : {{ticketNumber}}</span>
                    </p>
                </alert>
            </div>

            <div class="col-12 labelSection p-0">
                <label class="mt-4 ques quesLabel mb-3" [ngClass]="isArabic ? 'rightAlign' : ''">
                    <ng-container *ngIf="isViewMode">
                        <span *ngIf="!isArabic">Details of the new user you wanted to request access for:</span>
                        <span *ngIf="isArabic">تفاصيل المستخدم الجديد الذي أردت طلب الوصول إليه:</span>
                    </ng-container>
                    <ng-container *ngIf="!isViewMode">
                        <span *ngIf="!isArabic">Provide the details of the new user you want to request access
                            for:</span>
                        <span *ngIf="isArabic">:قدم تفاصيل المستخدم الجديد الذي تود تقديم طلب الصلاحية له</span>
                    </ng-container>
                </label>
            </div>
            <div class="bg-sky-blue">
            <div class="row border-top-form m-0" [ngClass]="isArabic ? 'arabicAlign' : ''">
                <div class="col-6">
                    <div class="labelSection">
                        <label class="mt-4 ques quesLabel" [ngClass]="isArabic ? 'rightAlign' : ''">
                            <!-- <span *ngIf="!isArabic">First Name :</span>
                            <span *ngIf="isArabic">: الأسم الاول</span> -->
                        </label>
                    </div>
                    <div class="ans-pnl">
                        <div class="inner1">
                            <div class="col-12 ratInput">
                                <input type="text" class="form-control" formControlName="firstName" id="firstName"
                                    [placeholder]="isArabic ? ':الاسم الاول' : 'First Name:'" required
                                    [ngClass]="isArabic ? 'rightAlign' : ''" (keydown)="checkAlphabets($event)"
                                    (paste)="onPaste($event)" maxlength="100" />
                            </div>
                        </div>
                    </div>
                    <div *ngIf="requestAccessForm.controls['firstName']!.invalid" class="errMsg"
                        [ngClass]="isArabic ? 'rightAlign' : ''">
                        <span *ngIf="(isSubmitted || requestAccessForm.controls['firstName']!.touched || requestAccessForm.controls['firstName']!.dirty) && 
                    requestAccessForm.controls['firstName']!.errors!['required']">
                            <span *ngIf="!isArabic">This field is required</span>
                            <span *ngIf="isArabic">هذا الحقل مطلوب</span>
                        </span>
                    </div>
                </div>
                <div class="col-6">
                    <div class="labelSection">
                        <label class="mt-4 ques quesLabel" [ngClass]="isArabic ? 'rightAlign' : ''">
                            <!-- <span *ngIf="!isArabic">Last Name :</span>
                            <span *ngIf="isArabic">: أسم العائلة</span> -->
                        </label>
                    </div>
                    <div class="ans-pnl">
                        <div class="inner1">
                            <div class="col-12 ratInput">
                                <input type="text" class="form-control" formControlName="lastName" id="lastName"
                                    [placeholder]="isArabic ? ':الاسم الأخير' : 'Last Name:'" required
                                    [ngClass]="isArabic ? 'rightAlign' : ''" (keydown)="checkAlphabets($event)"
                                    (paste)="onPaste($event)" maxlength="100" />
                            </div>
                        </div>
                    </div>
                    <div *ngIf="requestAccessForm.controls['lastName']!.invalid" class="errMsg"
                        [ngClass]="isArabic ? 'rightAlign' : ''">
                        <span *ngIf="(isSubmitted || requestAccessForm.controls['lastName']!.touched || requestAccessForm.controls['lastName']!.dirty) && 
                    requestAccessForm.controls['lastName']!.errors!['required']">
                            <span *ngIf="!isArabic">This field is required</span>
                            <span *ngIf="isArabic">هذا الحقل مطلوب</span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="row m-0" [ngClass]="isArabic ? 'arabicAlign' : ''">
                <div class="col-6">
                    <div class="labelSection">
                        <label class="mt-4 ques quesLabel" [ngClass]="isArabic ? 'rightAlign' : ''">
                            <!-- <span *ngIf="!isArabic">Email ID :</span>
                            <span *ngIf="isArabic">: البريد الالكتروني</span> -->
                        </label>
                    </div>
                    <div class="ans-pnl">
                        <div class="inner1">
                            <div class="col-12 ratInput">
                                <input type="text" class="form-control" formControlName="newUserEmail" id="newUserEmail"
                                    [placeholder]="isArabic ? ':البريد الالكتروني' : 'Email ID:'" required
                                    [ngClass]="isArabic ? 'rightAlign' : ''" maxlength="100" />
                            </div>
                        </div>
                    </div>
                    <div *ngIf="requestAccessForm.controls['newUserEmail']!.invalid" class="errMsg"
                        [ngClass]="isArabic ? 'rightAlign' : ''">
                        <span *ngIf="(isSubmitted || requestAccessForm.controls['newUserEmail']!.touched || requestAccessForm.controls['newUserEmail']!.dirty) && 
                    requestAccessForm.controls['newUserEmail']!.errors!['required']">
                            <span *ngIf="!isArabic">This field is required</span>
                            <span *ngIf="isArabic">هذا الحقل مطلوب</span>
                        </span>
                        <span *ngIf="isSubmitted && (!requestAccessForm.controls['newUserEmail']!.errors!['required'] &&
                    requestAccessForm.controls['newUserEmail']!.errors!['pattern'])">
                            <span *ngIf="!isArabic">Please provide a valid email address</span>
                            <span *ngIf="isArabic">يرجى تقديم عنوان بريد إلكتروني صالح</span>
                        </span>
                    </div>
                </div>
                <div class="col-6">
                    <div class="labelSection">
                        <label class="mt-4 ques quesLabel" [ngClass]="isArabic ? 'rightAlign' : ''">
                            <!-- <span *ngIf="!isArabic">Contact Number :</span>
                            <span *ngIf="isArabic">: رقم الاتصال</span> -->
                        </label>
                    </div>
                    <div class="ans-pnl">
                        <div class="row inner1">
                            <div class="col-4 ratInput countryDiv">
                                <span class="countrycode">
                                    <span class="plusSign">+</span>
                                    <input type="text" class="form-control" id="countrycode"
                                        [placeholder]="isArabic ? 'الرقم الدولي' : 'Country Code'"
                                        formControlName="countrycode" maxlength="3"
                                        [ngClass]="isArabic ? 'rightAlign' : ''" (keydown)="checkNumber($event)"
                                        (paste)="onPaste($event)">
                                </span>
                            </div>
                            <div class="col-8 ratInput">
                                <input type="text" class="form-control" formControlName="mobile" id="mobile"
                                    [placeholder]="isArabic ? ':رقم الاتصال' : 'Contact Number:'" required maxlength="10"
                                    (keydown)="checkNumber($event)" (paste)="onPaste($event)"
                                    [ngClass]="isArabic ? 'rightAlign' : ''" />
                            </div>
                        </div>
                    </div>
                    <div *ngIf="requestAccessForm!.controls['countrycode']?.invalid || requestAccessForm!.controls['mobile']?.invalid"
                        class="errMsg" [ngClass]="isArabic ? 'rightAlign' : ''">
                        <span
                            *ngIf="(isSubmitted || (requestAccessForm.controls['mobile']!.touched || requestAccessForm.controls['mobile']!.dirty ||
                    requestAccessForm.controls['countrycode']!.touched || requestAccessForm.controls['countrycode']!.dirty) )">
                            <span *ngIf="!isArabic">Both fields are required</span>
                            <span *ngIf="isArabic">كلا الحقلين مطلوبان</span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="row m-0" [ngClass]="isArabic ? 'arabicAlign' : ''">
                <div class="col-6">
                    <div class="labelSection">
                        <label class="mt-4 ques quesLabel" [ngClass]="isArabic ? 'rightAlign' : ''">
                            <!-- <span *ngIf="!isArabic">Assessment Entity :</span>
                            <span *ngIf="isArabic">: اسم المنشأة</span> -->
                        </label>
                    </div>
                    <div class="ans-pnl">
                        <div class="inner1">
                            <div class="col-12 ratInput">
                                <input type="text" class="form-control" 
                                [placeholder]="isArabic ? ':اسم المنشأة' : 'Assessment Entity:'" formControlName="assessmentUnit"
                                    id="assessmentUnit" [ngClass]="isArabic ? 'rightAlign' : ''" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="labelSection">
                        <label class="mt-4 ques quesLabel" [ngClass]="isArabic ? 'rightAlign' : ''">
                            <!-- <span *ngIf="!isArabic">Upload ID Proof :</span>
                            <span *ngIf="isArabic">: تحميل مستندات إثبات الشخصية</span> -->
                        </label>
                    </div>
                    <ng-container *ngIf="!isViewMode">
                        <div class="ans-pnl" [ngClass]="isArabic ? 'rightAlign' : ''">
                            <div class="inner1White">
                                <input type="file" class="rqstUserAccessFile font-radikal-light" name="notesName" #attachment
                                    [ngClass]="isArabic ? 'rightAlign' : ''" (change)="handleFileInput($event)"
                                    required />
                            </div>
                        </div>
                        <div [ngClass]="isArabic ? 'rightAlign' : ''">
                            <ng-container *ngIf="isSubmitted && isFileUploaded == undefined">
                                <span class="sizeErr">
                                    <span *ngIf="!isArabic" class="errMsg">Please upload a file</span>
                                    <span *ngIf="isArabic" class="errMsg">يرجى رفع ملف</span>
                                </span>
                            </ng-container>
                            <ng-container *ngIf="isFileUploaded !== undefined">
                                <span *ngIf="fileTypeErr" class="sizeErr">
                                    <span *ngIf="!isArabic" class="errMsg">Please select file having extensions
                                        .doc/.docx/.pdf/.txt only.</span>
                                    <span *ngIf="isArabic" class="errMsg">يرجى اختيار ملف بالامتدادات التالية فقط .doc/ .docx / .pdf / .txt فقط.</span>
                                </span>
                                <span *ngIf="showSizeErr" class="sizeErr">
                                    <span *ngIf="!isArabic" class="errMsg">File size exceeded 20mb</span>
                                    <span *ngIf="isArabic" class="errMsg">20MB حجم الملف يتعدى</span>
                                </span>
                                <span *ngIf="fileUploadErr" class="sizeErr">
                                    <span *ngIf="!isArabic" class="errMsg">File has not been uploaded</span>
                                    <span *ngIf="isArabic" class="errMsg">لم يتم تحميل الملف</span>
                                </span>
                            </ng-container>
                        </div>
                        <div class="noteGuidance mt-4" [ngClass]="isArabic ? 'rightAlign' : ''">
                            <span *ngIf="isArabic">* يمكنك اختيار ملف واحد ذو حجم 20MB بشكل أقصى وذو طبيعة.JPEG أو .pdf. سيتم تحميل الملف بعد الضغط على زر "ارسال"</span>
                            <span *ngIf="!isArabic">* You can select a maximum of 1 file with a maximum size of 20mb. The
                                file will be uploaded once you click "Submit".</span>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="isViewMode">
                        <div class="ans-pnl">
                            <div class="inner1White">
                                <div class="urlDiv" [ngClass]="isArabic ? 'rightAlign' : ''">
                                    <span class="font-radikal-light">{{uploadedFileName}}</span>
                                    <!-- <a class="dwnld" (click)="handleFileLinkClick()">
                                        <span *ngIf="!isArabic">Download</span>
                                        <span *ngIf="isArabic">تحميل</span>
                                    </a> -->
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>

            </div>
            <!-- resolution comment -->
            <div *ngIf="isViewMode" class="row" [ngClass]="isArabic ? 'arabicAlign' : ''">
                <div class="col-12 px-4 pb-4">
                    <div class="labelSection">
                        <label class="mt-4 ques quesLabel" [ngClass]="isArabic ? 'rightAlign' : ''">
                            <span *ngIf="!isArabic">Resolution Comment :</span>
                            <span *ngIf="isArabic">: تعليقات القرار</span>
                        </label>
                    </div>
                    <ng-container *ngIf="comments">
                        <div class="ans-pnl">
                            <div class="inner1">
                                <div class="col-12 ratInput">
                                    <textarea class="form-control font-radikal-light" formControlName="resolutionComment"
                                        id="resolutionComment"
                                        [placeholder]="isArabic ? 'لا توجد تعليقات متاحة' : 'No comments available' "
                                        [ngClass]="isArabic ? 'rightAlign' : ''" maxlength="3000"></textarea>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="!comments">
                        <div class="no-comments font-radikal-light" [ngClass]="isArabic ? 'rightAlign' : ''">
                            {{isArabic ? 'لا توجد تعليقات متاحة' : 'No comments available'}}
                        </div>
                    </ng-container>
                </div>
            </div>
            </div>
            <div class="row mt-3" *ngIf="serverErr">
                <div class="col-12">
                    <div class="errMsg serverErr">
                        <span>{{serverErr}}</span>
                    </div>
                </div>
            </div>

            <div class="row bg-sky-blue border-bottom-form m-0">
                <div class="col-12 submitBtnDiv text-end" *ngIf="!isViewMode">
                    <button type="button" class="btn btn-lg btn-primary submitBtn" type="submit"
                        (click)="checkIfUserRequestExists()" [disabled]="disabledBtn">
                        <span *ngIf="!isArabic">Submit</span><span *ngIf="isArabic">تقديم وإنهاء</span></button>
                </div>
            </div>
        </div>
    </form>
</div>
